import React from 'react';

import styles from './Title.module.css';

const title = (props) => (
  <div className={styles.Title}><h1>{props.text}</h1></div>
);

export default title;
